export interface EnrollProgressItem {
  title: string;
  completed?: boolean;
  order?: number;
}
export enum EnrollmentScenario {
  free,
  payment,
}
